module.exports = __webpack_public_path__ + "f87e657c1e0869a64b93b57cb695dd84.svg";